import type { DetectedLink } from '../../integrations';

/** Detects Slack thread or channel links. Channel-only links have isChannel: true (not fetchable). */
export function detectSlackLink(url: string): DetectedLink | null {
  const archiveThreadMatch = url.match(
    /https?:\/\/(?:([^./]+)\.)?slack\.com\/archives\/([A-Z0-9]+)\/p(\d+)(?:\?.*)?$/i
  );
  if (archiveThreadMatch) {
    return {
      url,
      integrationType: 'slack',
      resourceType: 'thread',
      resourceId: `${archiveThreadMatch[2]}-${archiveThreadMatch[3]}`,
      isChannel: false,
    };
  }
  const appThreadMatch = url.match(
    /https?:\/\/app\.slack\.com\/client\/([^/]+)\/([A-Z0-9]+)\/thread\/[A-Z0-9]+-(\d+)/i
  );
  if (appThreadMatch) {
    return {
      url,
      integrationType: 'slack',
      resourceType: 'thread',
      resourceId: `${appThreadMatch[2]}-${appThreadMatch[3]}`,
      isChannel: false,
    };
  }
  const channelOnlyMatch = url.match(
    /https?:\/\/(?:app\.)?(?:([^./]+)\.)?slack\.com\/archives\/([A-Z0-9]+)\/?(\?.*)?$/i
  );
  if (channelOnlyMatch && !url.includes('/p')) {
    return {
      url,
      integrationType: 'slack',
      resourceType: 'channel',
      resourceId: channelOnlyMatch[2],
      isChannel: true,
    };
  }
  return null;
}
